
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFeedWhitePaper"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhitePaper"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachmentExtensions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tagList"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thesis"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whitePaperAttachments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filename"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"wpElevatorPitch"},"name":{"kind":"Name","value":"elevatorPitch"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"wpUpdatedAt"},"name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"wpUser"},"name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedUser"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResearchItemUser"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isRanked"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundProfile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"youtubeIds"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhitePaperCategoryNames"},"directives":[]}]}}],"loc":{"start":0,"end":541}};
    doc.loc.source = {"body":"#import './ActivityFeedUser.graphql'\n#import '../fragments/WhitePaperCategoryNames.graphql'\n#import '../fragments/ResearchItemUser.graphql'\n\nfragment ActivityFeedWhitePaper on WhitePaper {\n  id\n  attachmentExtensions\n  commentsCount\n  submittedAt\n  tagList\n  thesis\n  title\n  whitePaperAttachments {\n    id\n    filename\n  }\n  wpElevatorPitch: elevatorPitch\n  wpUpdatedAt: updatedAt\n  wpUser: user {\n    ...ActivityFeedUser\n    ...ResearchItemUser\n    isRanked\n    fundProfile {\n      id\n    }\n  }\n  youtubeIds\n  ...WhitePaperCategoryNames\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedUser.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/WhitePaperCategoryNames.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/ResearchItemUser.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ActivityFeedWhitePaper"] = oneQuery(doc, "ActivityFeedWhitePaper");
        
